@if(role==='ADMIN_INSURER' || role==='ADMIN_PROVIDER' || role==='ADMIN_DISTRIBUTOR' ){
<div class="city-card-stack" (click)="onCardClick()">
    <div class="city-card-main matter-container">
        <div class="top-section">
            <div class="left-info d-flex align-items-center gap-3">
                <div class="photo">
                    {{ insurer.firstName | initials:insurer.lastName }}
                </div>
                <div class="name-contact">
                    <p class="fs-13 fw-500">{{ insurer.firstName }} {{ insurer.lastName }}</p>
                    <div class="info-line fs-11">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                            fill="#0075C9">
                            <path
                                d="M2 3h20c1.05 0 2 .95 2 2v14c0 1.05-.95 2-2 2H2c-1.05 0-2-.95-2-2V5c0-1.05.95-2 2-2m12 3v1h8V6zm0 2v1h8V8zm0 2v1h7v-1zm-6 3.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09M8 6a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3" />
                        </svg>
                        <span [ngClass]="insurer.isactive ? 'active' : 'inactive'">{{ insurer.isactive ? 'Active' :
                            'Deactived' }}</span>
                    </div>
                </div>
            </div>
            <div class="action-buttons d-flex align-items-center gap-2">
                @if (insurer?.isactive==false) {
                <span class="icon-btn" matTooltip="Activate" matTooltipPosition="below"
                    (click)="onStatusUpdate(true); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#53e643" fill-rule="evenodd"
                            d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
                    </svg>
                </span>
                } @else if (insurer?.isactive===true) {
                <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="below"
                    (click)="onStatusUpdate(false); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                        <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z"
                            stroke-width="0.1" stroke="#e84721" />
                    </svg>
                </span>
                }
                <span class="icon-btn" matTooltip="Edit" matTooltipPosition="below"
                    (click)="onEditAgent(); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                        <path fill="#0075C9" fill-rule="evenodd"
                            d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#0075C9" />
                        <path fill="#0075C9"
                            d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                            stroke-width="0.1" stroke="#0075C9" />
                    </svg>
                </span>
            </div>
        </div>

        <div class="city-card-bg-number">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24">
                <path fill="#0075C9"
                    d="M12 23C6.443 21.765 2 16.522 2 11V5l10-4l10 4v6c0 5.524-4.443 10.765-10 12M4 6v5a10.58 10.58 0 0 0 8 10a10.58 10.58 0 0 0 8-10V6l-8-3Z" />
                <circle cx="12" cy="8.5" r="2.5" fill="#0075C9" />
                <path fill="#0075C9"
                    d="M7 15a5.78 5.78 0 0 0 5 3a5.78 5.78 0 0 0 5-3c-.025-1.896-3.342-3-5-3c-1.667 0-4.975 1.104-5 3" />
            </svg>
        </div>

        <div class="address fs-11">
            @if(role==='ADMIN_INSURER' || role==='ADMIN_PROVIDER' || role==='ADMIN_DISTRIBUTOR' ){
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
                <path fill="#0075C9"
                    d="M216 34h-48a6 6 0 0 0 0 12h33.52l-46.8 46.79a78 78 0 1 0 4.42 114.4a78.11 78.11 0 0 0 4.07-105.91L210 54.49V88a6 6 0 0 0 12 0V40a6 6 0 0 0-6-6m-65.34 164.7a66 66 0 1 1 0-93.36a66.1 66.1 0 0 1 0 93.36" />
            </svg>
            <span>{{ insurer.gender  ||'NA'}}</span> |

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
                <path fill="#0075C9"
                    d="M228 112a20 20 0 0 0-20-20h-76V75.71A28 28 0 0 0 156 48c0-25.84-24.73-42.63-25.78-43.33a4 4 0 0 0-4.44 0C124.73 5.37 100 22.16 100 48a28 28 0 0 0 24 27.71V92H48a20 20 0 0 0-20 20v23.33a36.85 36.85 0 0 0 8 22.91V200a20 20 0 0 0 20 20h144a20 20 0 0 0 20-20v-41.76a36.85 36.85 0 0 0 8-22.91ZM108 48c0-17.39 14.37-30.53 20-35c5.63 4.48 20 17.62 20 35a20 20 0 0 1-40 0m92 164H56a12 12 0 0 1-12-12v-34.27A35.16 35.16 0 0 0 63 172a36.13 36.13 0 0 0 33-19.48a36 36 0 0 0 64 0A36.13 36.13 0 0 0 192 172h1a35.16 35.16 0 0 0 19-6.26V200a12 12 0 0 1-12 12m20-76.67c0 15.39-12.21 28.25-27.21 28.66A28 28 0 0 1 164 136a4 4 0 0 0-8 0a28 28 0 0 1-56 0a4 4 0 0 0-8 0a28 28 0 0 1-28.79 28c-15-.41-27.21-13.27-27.21-28.66V112a12 12 0 0 1 12-12h160a12 12 0 0 1 12 12Z" />
            </svg>
            <span>{{ insurer.dateOfBirth  ||'NA'}}</span>}
            </div>

                    <div class="address fs-11">


            <!-- @else if (role==='ADMIN_PROVIDER' || role==='ADMIN_INSURER' || role==='ADMIN_DISTRIBUTOR' ) { -->
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0079C5"
                    d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1"
                    opacity="0.5" />
                <path fill="#0079C5"
                    d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3" />
            </svg>
            <span>{{ insurer.activeStartDate | date : 'dd-MMM-yyyy'   }}</span> |
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0079C5"
                    d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1"
                    opacity="0.5" />
                <path fill="#0079C5"
                    d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3" />
            </svg>
            <span>{{ insurer.activeEndDate | date:'dd-MMM-yyyy' }}</span>
            </div>

            <!-- } -->
        


        <div class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0075C9"
                    d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" />
            </svg>
            <span>{{ insurer.phone ||'NA' }}</span> |

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
                <path fill="#0075C9"
                    d="M248 212h-20V92h4a4 4 0 0 0 0-8h-52V44h4a4 4 0 0 0 0-8H40a4 4 0 0 0 0 8h4v168H24a4 4 0 0 0 0 8h224a4 4 0 0 0 0-8M220 92v120h-40V92ZM52 44h120v168h-32v-52a4 4 0 0 0-4-4H88a4 4 0 0 0-4 4v52H52Zm80 168H92v-48h40ZM76 80a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8H80a4 4 0 0 1-4-4m48 0a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4m-44 44a4 4 0 0 1 0-8h16a4 4 0 0 1 0 8Zm44-4a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4" />
            </svg>
            <span>{{ insurer.org[0]?.tradingName || 'NA'}}</span>
            <!-- @else if (role==='ADMIN_PROVIDER') { -->
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0075C9"
                    d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" />
            </svg>
            <span>{{ insurer.phone || 'NA'}}</span> | -->
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path fill="none" stroke="#0075c9" stroke-linecap="round" stroke-linejoin="round"
                    d="m5.5 10.5l5-5M3.73 6.61L2.67 7.67a4 4 0 1 0 5.66 5.66l1.06-1.06m2.88-2.88l1.06-1.06a4 4 0 1 0-5.66-5.66L6.61 3.73"
                    stroke-width="0.5" />
            </svg>
            <span>{{insurer.websiteUrl || 'NA'}}</span> -->

            <!-- } -->

        </div>

        <div class="address fs-11">
            <span class="copy-icon" (click)="copyToClipboard(insurer.email); $event.stopPropagation()">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                    <path fill="#1976d2"
                        d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                </svg>
            </span>
            <span>{{ insurer.email || 'NA' }}</span>
            <span *ngIf="copiedEmail === insurer.email" class="copied-text"
                style="margin-left:6px; color: #43a047; font-size: 0.85em;">
                Copied!
            </span>
        </div>

        <div class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0075C9" viewBox="0 0 24 24">
                <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5z" />
            </svg>
            <span>{{ insurer.address || 'NA' }}</span>
        </div>

        <div *ngIf="insurer.providers?.length" class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
                <path fill="#0075C9"
                    d="M248 212h-20V92h4a4 4 0 0 0 0-8h-52V44h4a4 4 0 0 0 0-8H40a4 4 0 0 0 0 8h4v168H24a4 4 0 0 0 0 8h224a4 4 0 0 0 0-8M220 92v120h-40V92ZM52 44h120v168h-32v-52a4 4 0 0 0-4-4H88a4 4 0 0 0-4 4v52H52Zm80 168H92v-48h40ZM76 80a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8H80a4 4 0 0 1-4-4m48 0a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4m-44 44a4 4 0 0 1 0-8h16a4 4 0 0 1 0 8Zm44-4a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4" />
            </svg>
            <span> {{ insurer.providers[0]?.name  || 'NA'}}
            </span>
        </div>

    </div>
    <div class="city-card-footer">
        {{ insurer.lastupdatedon | date : 'dd-MMM-yyyy HH:mm' }}
    </div>

</div>
}





@else if(role==='INSURER_ORG' || role==='PROVIDER_ORG' || role==='DISTRIBUTOR_ORG' ){
<div class="city-card-stack" >
    <div class="city-card-main matter-container">
        <div class="top-section">
            <div class="left-info d-flex align-items-center gap-3">
                <div class="photo">
                    {{insurer?.tradingName | initials:insurer.tradingName  }}
                </div>
                <div class="name-contact">
                    <p class="fs-13 fw-500">{{ insurer?.tradingName }} </p>
                    <div class="info-line fs-11">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                            fill="#0075C9">
                            <path
                                d="M2 3h20c1.05 0 2 .95 2 2v14c0 1.05-.95 2-2 2H2c-1.05 0-2-.95-2-2V5c0-1.05.95-2 2-2m12 3v1h8V6zm0 2v1h8V8zm0 2v1h7v-1zm-6 3.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09M8 6a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3" />
                        </svg>
                        <span [ngClass]="insurer?.isactive ? 'active' : 'inactive'">{{ insurer?.isactive ? 'Active' :
                            'Deactived' }}</span>
                    </div>
                </div>
            </div>
            <div class="action-buttons d-flex align-items-center gap-2">
                @if (insurer?.isactive==false) {
                <span class="icon-btn" matTooltip="Activate" matTooltipPosition="below"
                    (click)="onStatusUpdate(true); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#53e643" fill-rule="evenodd"
                            d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
                    </svg>
                </span>
                } @else if (insurer?.isactive===true) {
                <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="below"
                    (click)="onStatusUpdate(false); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                        <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z"
                            stroke-width="0.1" stroke="#e84721" />
                    </svg>
                </span>
                }
                <span class="icon-btn" matTooltip="Edit" matTooltipPosition="below"
                    (click)="onEditAgent(); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                        <path fill="#0075C9" fill-rule="evenodd"
                            d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#0075C9" />
                        <path fill="#0075C9"
                            d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                            stroke-width="0.1" stroke="#0075C9" />
                    </svg>
                </span>
            </div>
        </div>

        <div class="city-card-bg-number">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24">
                <path fill="#0075C9"
                    d="M12 23C6.443 21.765 2 16.522 2 11V5l10-4l10 4v6c0 5.524-4.443 10.765-10 12M4 6v5a10.58 10.58 0 0 0 8 10a10.58 10.58 0 0 0 8-10V6l-8-3Z" />
                <circle cx="12" cy="8.5" r="2.5" fill="#0075C9" />
                <path fill="#0075C9"
                    d="M7 15a5.78 5.78 0 0 0 5 3a5.78 5.78 0 0 0 5-3c-.025-1.896-3.342-3-5-3c-1.667 0-4.975 1.104-5 3" />
            </svg>
        </div>

        <div class="address fs-11">
            @if(role==='INSURER_ORG' || role==='PROVIDER_ORG' || role==='DISTRIBUTOR_ORG' ){
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12"><path fill="#0075C9" d="M6 1a2 2 0 1 0 0 4a2 2 0 0 0 0-4M5 3a1 1 0 1 1 2 0a1 1 0 0 1-2 0m3.5 3h-5A1.5 1.5 0 0 0 2 7.5c0 1.116.459 2.01 1.212 2.615C3.953 10.71 4.947 11 6 11s2.047-.29 2.788-.885C9.54 9.51 10 8.616 10 7.5A1.5 1.5 0 0 0 8.5 6m-5 1h5a.5.5 0 0 1 .5.5c0 .817-.325 1.423-.838 1.835C7.636 9.757 6.88 10 6 10s-1.636-.243-2.162-.665C3.325 8.923 3 8.317 3 7.5a.5.5 0 0 1 .5-.5"/></svg>

            <span>{{ insurer?.contactPerson ||'NA'}}</span> |

           

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="none" stroke="#0075c9" stroke-linecap="round" stroke-linejoin="round" d="m5.5 10.5l5-5M3.73 6.61L2.67 7.67a4 4 0 1 0 5.66 5.66l1.06-1.06m2.88-2.88l1.06-1.06a4 4 0 1 0-5.66-5.66L6.61 3.73" stroke-width="0.5"/></svg>
            <span>{{ insurer?.websiteUrl  ||'NA'}}</span>}
            </div>

                    <div class="address fs-11">


            <!-- @else if (role==='ADMIN_PROVIDER' || role==='ADMIN_INSURER' || role==='ADMIN_DISTRIBUTOR' ) { -->
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0079C5"
                    d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1"
                    opacity="0.5" />
                <path fill="#0079C5"
                    d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3" />
            </svg>
            <span>{{ insurer?.activeStartDate | date : 'dd-MMM-yyyy'   }}</span> |
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0079C5"
                    d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1"
                    opacity="0.5" />
                <path fill="#0079C5"
                    d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3" />
            </svg>
            <span>{{ insurer?.activeEndDate | date:'dd-MMM-yyyy' }}</span>
            </div>

            <!-- } -->
        


        <div class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0075C9"
                    d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" />
            </svg>
            <span>{{ insurer?.contactPhone ||'NA' }}</span> |

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
                <path fill="#0075C9"
                    d="M248 212h-20V92h4a4 4 0 0 0 0-8h-52V44h4a4 4 0 0 0 0-8H40a4 4 0 0 0 0 8h4v168H24a4 4 0 0 0 0 8h224a4 4 0 0 0 0-8M220 92v120h-40V92ZM52 44h120v168h-32v-52a4 4 0 0 0-4-4H88a4 4 0 0 0-4 4v52H52Zm80 168H92v-48h40ZM76 80a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8H80a4 4 0 0 1-4-4m48 0a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4m-44 44a4 4 0 0 1 0-8h16a4 4 0 0 1 0 8Zm44-4a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4" />
            </svg>
            <span>{{ insurer?.fcaReferenceNumber || 'NA'}}</span>
            <!-- @else if (role==='ADMIN_PROVIDER') { -->
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0075C9"
                    d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" />
            </svg>
            <span>{{ insurer.phone || 'NA'}}</span> | -->
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path fill="none" stroke="#0075c9" stroke-linecap="round" stroke-linejoin="round"
                    d="m5.5 10.5l5-5M3.73 6.61L2.67 7.67a4 4 0 1 0 5.66 5.66l1.06-1.06m2.88-2.88l1.06-1.06a4 4 0 1 0-5.66-5.66L6.61 3.73"
                    stroke-width="0.5" />
            </svg>
            <span>{{insurer.websiteUrl || 'NA'}}</span> -->

            <!-- } -->

        </div>

        <div class="address fs-11">
            <span class="copy-icon" (click)="copyToClipboard(insurer?.email); $event.stopPropagation()">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                    <path fill="#1976d2"
                        d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                </svg>
            </span>
            <span>{{ insurer?.email || 'NA' }}</span>
            <span *ngIf="copiedEmail === insurer.email" class="copied-text"
                style="margin-left:6px; color: #43a047; font-size: 0.85em;">
                Copied!
            </span>
        </div>

        <div class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0075C9" viewBox="0 0 24 24">
                <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5z" />
            </svg>
            <span>{{ insurer.address || 'NA' }}</span>
        </div>

        <div *ngIf="insurer.providers?.length" class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
                <path fill="#0075C9"
                    d="M248 212h-20V92h4a4 4 0 0 0 0-8h-52V44h4a4 4 0 0 0 0-8H40a4 4 0 0 0 0 8h4v168H24a4 4 0 0 0 0 8h224a4 4 0 0 0 0-8M220 92v120h-40V92ZM52 44h120v168h-32v-52a4 4 0 0 0-4-4H88a4 4 0 0 0-4 4v52H52Zm80 168H92v-48h40ZM76 80a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8H80a4 4 0 0 1-4-4m48 0a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4m-44 44a4 4 0 0 1 0-8h16a4 4 0 0 1 0 8Zm44-4a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4" />
            </svg>
            <span> {{ insurer.providers[0]?.name  || 'NA'}}
            </span>
        </div>

    </div>
    <div class="city-card-footer">
        {{ insurer?.lastupdatedon | date : 'dd-MMM-yyyy HH:mm' }}
    </div>

</div>
}

<!-- @if(role==='ADMIN_DISTRIBUTOR'){ -->
<!-- <p>{{insurer.tradingName}}</p> -->


<!-- <div class="city-card-stack" (click)="onCardClick()">
    <div class="city-card-main matter-container">
        <div class="top-section">
            <div class="left-info d-flex align-items-center gap-3">
                <div class="photo">
                    {{ insurer.contactPerson | initials}}  
                </div>
                <div class="name-contact">
                    <p class="fs-13 fw-500">{{ insurer.contactPerson}} </p>
                    <div class="info-line fs-11">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                            fill="#0075C9">
                            <path
                                d="M2 3h20c1.05 0 2 .95 2 2v14c0 1.05-.95 2-2 2H2c-1.05 0-2-.95-2-2V5c0-1.05.95-2 2-2m12 3v1h8V6zm0 2v1h8V8zm0 2v1h7v-1zm-6 3.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09M8 6a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3" />
                        </svg>
                        <span [ngClass]="insurer.isactive ? 'active' : 'inactive'">{{ insurer.isactive ? 'Active' :
                            'Deactived' }}</span>
                    </div>
                </div>
            </div>
            <div class="action-buttons d-flex align-items-center gap-2">
                @if (!insurer.isactive) {
                <span class="icon-btn" matTooltip="Activate" matTooltipPosition="below"
                    (click)="onStatusUpdate(true); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#53e643" fill-rule="evenodd"
                            d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
                    </svg>
                </span>
                } @else {
                <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="below"
                    (click)="onStatusUpdate(false); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                        <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z"
                            stroke-width="0.1" stroke="#e84721" />
                    </svg>
                </span>
                }
                <span class="icon-btn" matTooltip="Edit" matTooltipPosition="below"
                    (click)="onEditAgent(); $event.stopPropagation(); $event.preventDefault()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                        <path fill="#0075C9" fill-rule="evenodd"
                            d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                            clip-rule="evenodd" stroke-width="0.1" stroke="#0075C9" />
                        <path fill="#0075C9"
                            d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                            stroke-width="0.1" stroke="#0075C9" />
                    </svg>
                </span>
            </div>
        </div>

        <div class="city-card-bg-number">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24">
                <path fill="#0075C9"
                    d="M12 23C6.443 21.765 2 16.522 2 11V5l10-4l10 4v6c0 5.524-4.443 10.765-10 12M4 6v5a10.58 10.58 0 0 0 8 10a10.58 10.58 0 0 0 8-10V6l-8-3Z" />
                <circle cx="12" cy="8.5" r="2.5" fill="#0075C9" />
                <path fill="#0075C9"
                    d="M7 15a5.78 5.78 0 0 0 5 3a5.78 5.78 0 0 0 5-3c-.025-1.896-3.342-3-5-3c-1.667 0-4.975 1.104-5 3" />
            </svg>
        </div>

        <div class="address fs-11"> -->
            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
                <path fill="#0075C9"
                    d="M216 34h-48a6 6 0 0 0 0 12h33.52l-46.8 46.79a78 78 0 1 0 4.42 114.4a78.11 78.11 0 0 0 4.07-105.91L210 54.49V88a6 6 0 0 0 12 0V40a6 6 0 0 0-6-6m-65.34 164.7a66 66 0 1 1 0-93.36a66.1 66.1 0 0 1 0 93.36" />
            </svg> -->


            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0079C5"
                    d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1"
                    opacity="0.5" />
                <path fill="#0079C5"
                    d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3" />
            </svg>
            <span>{{ insurer.activeStartDate | date : 'dd-MMM-yyyy' }}</span> |
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0079C5"
                    d="M22 10H2v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zM7 8a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1m10 0a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1"
                    opacity="0.5" />
                <path fill="#0079C5"
                    d="M19 4h-1v3a1 1 0 0 1-2 0V4H8v3a1 1 0 0 1-2 0V4H5a3 3 0 0 0-3 3v3h20V7a3 3 0 0 0-3-3" />
            </svg>
            <span>{{ insurer.activeEndDate | date:'dd-MMM-yyyy' }}</span>
        </div>
 -->

        <!-- <div class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="#0075C9"
                    d="M19.5 22a1.5 1.5 0 0 0 1.5-1.5V17a1.5 1.5 0 0 0-1.5-1.5c-1.17 0-2.32-.18-3.42-.55a1.51 1.51 0 0 0-1.52.37l-1.44 1.44a14.77 14.77 0 0 1-5.89-5.89l1.43-1.43c.41-.39.56-.97.38-1.53c-.36-1.09-.54-2.24-.54-3.41A1.5 1.5 0 0 0 7 3H3.5A1.5 1.5 0 0 0 2 4.5C2 14.15 9.85 22 19.5 22M3.5 4H7a.5.5 0 0 1 .5.5c0 1.28.2 2.53.59 3.72c.05.14.04.34-.12.5L6 10.68c1.65 3.23 4.07 5.65 7.31 7.32l1.95-1.97c.14-.14.33-.18.51-.13c1.2.4 2.45.6 3.73.6a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5C10.4 21 3 13.6 3 4.5a.5.5 0 0 1 .5-.5" />
            </svg>
            <span>{{ insurer.contactPhone || 'NA' }}</span> |

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
                <path fill="#0075C9"
                    d="M248 212h-20V92h4a4 4 0 0 0 0-8h-52V44h4a4 4 0 0 0 0-8H40a4 4 0 0 0 0 8h4v168H24a4 4 0 0 0 0 8h224a4 4 0 0 0 0-8M220 92v120h-40V92ZM52 44h120v168h-32v-52a4 4 0 0 0-4-4H88a4 4 0 0 0-4 4v52H52Zm80 168H92v-48h40ZM76 80a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8H80a4 4 0 0 1-4-4m48 0a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4m-44 44a4 4 0 0 1 0-8h16a4 4 0 0 1 0 8Zm44-4a4 4 0 0 1 4-4h16a4 4 0 0 1 0 8h-16a4 4 0 0 1-4-4" />
            </svg>
            
            <span>{{insurer.tradingName || 'NA'}}</span>
        </div>
        <div class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                            fill="#0075C9">
                            <path
                                d="M2 3h20c1.05 0 2 .95 2 2v14c0 1.05-.95 2-2 2H2c-1.05 0-2-.95-2-2V5c0-1.05.95-2 2-2m12 3v1h8V6zm0 2v1h8V8zm0 2v1h7v-1zm-6 3.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09M8 6a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3" />
                        </svg>  <span>{{insurer.fcaReferenceNumber || 'NA'}}</span>

        </div>
 -->
        <!-- <div class="address fs-11">
            <span class="copy-icon" (click)="copyToClipboard(insurer.email); $event.stopPropagation()">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                    <path fill="#1976d2"
                        d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m0 16H8V7h11z" />
                </svg>
            </span>
            <span>{{ insurer.email   || 'NA' }}</span>
            <span *ngIf="copiedEmail === insurer.email" class="copied-text"
                style="margin-left:6px; color: #43a047; font-size: 0.85em;">
                Copied!
            </span>
        </div>

        <div class="address fs-11">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0075C9" viewBox="0 0 24 24">
                <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 14.5 9 2.5 2.5 0 0 1 12 11.5z" />
            </svg>
            <span>{{ insurer.address || 'NA' }}</span>
        </div>
        <div class="address fs-11">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                            fill="#0075C9">
                            <path
                                d="M2 3h20c1.05 0 2 .95 2 2v14c0 1.05-.95 2-2 2H2c-1.05 0-2-.95-2-2V5c0-1.05.95-2 2-2m12 3v1h8V6zm0 2v1h8V8zm0 2v1h7v-1zm-6 3.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09M8 6a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3" />
                        </svg>  <span >{{insurer.insurers[0]?.name  || 'NA'}} </span>
        </div>

    </div>
    <div class="city-card-footer">
        {{ insurer.lastupdatedon | date : 'dd-MMM-yyyy HH:mm' }}

    </div> -->
    <!-- <div *ngFor="let adminInsurer of insurer.insurers"></div> -->
    <!-- <div>

    </div>
</div> -->

<!-- } -->